import React, { useState, useEffect } from "react";
import Image from "next/image";

interface CarouselItem {
    logo: string;
    title: string;
    subtext: string;
    description: string;
    link: string;
    imageUrl: string;
}

const CarouselItem: React.FC<{ items: CarouselItem[] }> = ({ items }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, []);

    return (
        <div className="lg:pb-20 pb-10">
            <div className="bg-gray-100 max-w-6xl mx-auto relative">
                <div className="overflow-hidden">
                    <div className="flex">
                        {items.map((item, index) => (
                            <div key={index} className={`w-full flex  ${index === currentIndex ? "" : "hidden"} transition-opacity duration-500`}>
                                <div className="flex flex-col md:flex-row  w-full">
                                    <div className="md:w-1/2  space-y-4 p-8">
                                        <div className="flex flex-row  w-full">
                                            <div className="bg-white w-20 h-20 mr-4">
                                                <img width="80px" height="80px" loading="lazy" src={item.logo} alt={`${item.title} logo`} />
                                            </div>
                                            <div className="w-1/2">
                                                <div>{item.title}</div>
                                                <div>{item.subtext}</div>
                                            </div>
                                        </div>
                                        <div className="">{item.description}</div>
                                        <div className="pt-10">
                                            <a
                                                href={item.link}
                                                className="mt-4 text-blue-500 hover:underline justify-start"
                                                style={{ display: "inline-flex", alignItems: "center" }}
                                            >
                                                Learn More
                                                <span style={{ marginLeft: "4px" }}>{">"}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="md:w-1/2 p-4">
                                        <Image className="bg-white rounded-xl" width={555} height={320} src={item.imageUrl} alt={item.title} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="lg:block hidden">
                    {loaded && (
                        <div className="carousal-dots absolute bottom-10 left-8">
                            {[...Array(items.length).keys()].map((idx) => (
                                <button
                                    key={idx}
                                    onClick={() => {
                                        setCurrentIndex(idx);
                                    }}
                                    className={`carousal-dot ${currentIndex === idx ? "active" : ""}`}
                                ></button>
                            ))}
                        </div>
                    )}
                </div>
                <div className="lg:hidden block">
                    {loaded && (
                        <div className="carousal-dots ">
                            {[...Array(items.length).keys()].map((idx) => (
                                <button
                                    key={idx}
                                    onClick={() => {
                                        setCurrentIndex(idx);
                                    }}
                                    className={`carousal-dot ${currentIndex === idx ? "active" : ""}`}
                                ></button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CarouselItem;
